import { AuthType } from "../models/enums/auth-type.enum";
import { AdminBuilder } from "./admin.builder";

export class Admin {
  public readonly type: AuthType;
  public readonly description: string;
  public readonly venues: string[];
  public readonly cities: string[];
  public readonly createdBy: string;
  public readonly editedBy: string;
  public readonly hasFullAccess: boolean;

  constructor(builder: AdminBuilder) {
    this.type = builder.type;
    this.description = builder.description;
    this.venues = builder.venues;
    this.cities = builder.cities;
    this.createdBy = builder.createdBy;
    this.editedBy = builder.editedBy;
    this.hasFullAccess = builder.hasFullAccess;
  }

  toJSON() {
    return {
      hasFullAccess: this.hasFullAccess,
      type: this.type,
      description: this.description,
      venues: this.venues,
      cities: this.cities,
      createdBy: this.createdBy,
      editedBy: this.editedBy
    };
  }
}
